import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const durchschnittReducer = (state = {
    BarDiagrammDurchschnittUI: [],
    BarDiagrammUpdateDurchschnittUI: null,
    UpdateMessage: '',
    UpdateSuccess: false,
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_BarDiagrammDurchschnitt_durchschnittReducer":
            return { ...state, BarDiagrammDurchschnittUI: action.value, isLoaded: true };
        case "RECEIVE_BarDiagrammDurchschnittUpdate_durchschnittReducer":
            return {
                ...state,
                BarDiagrammUpdateDurchschnittUI: action.value,
                UpdateMessage: action.value?.message || '',
                UpdateSuccess: action.value?.success || false,
                isLoaded: true
            };
        case "RESET_BarDiagrammDurchschnittUpdate_durchschnittReducer":
            return { ...state, BarDiagrammUpdateDurchschnittUI: null, UpdateMessage: '', UpdateSuccess: false, isLoaded: state.isLoaded !== undefined ? state.isLoaded : true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, BarDiagrammDurchschnittUI: [], BarDiagrammUpdateDurchschnittUI: null, UpdateMessage: '', UpdateSuccess: false, isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default durchschnittReducer;
